module.exports = __webpack_public_path__ + "assets/world.6347a8b5.svg";